import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "breadcrumb-wrap" }
const _hoisted_2 = { "aria-label": "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home mr-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("nav", _hoisted_2, [
      _createVNode("ol", _hoisted_3, [
        _createVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, { to: { name: 'admin-dashboard' } }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_7, [
          (_ctx.project && _ctx.project.name)
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectToProject(_ctx.project)))
              }, _toDisplayString(_ctx.project.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("li", _hoisted_8, _toDisplayString(_ctx.breadCrumbEndPoint), 1)
      ])
    ])
  ]))
}